export default function VideoTag() {
  return <>VideoTag</>;
}
